/* eslint-disable no-console */
import Application from '@ember/application';
import Resolver from './resolver';
import loadInitializers from 'ember-load-initializers';
import config from './config/environment';
import { startSentry } from './sentry';
import 'ember-cached-decorator-polyfill';
import { macroCondition, isDevelopingApp, importSync } from '@embroider/macros';

import './utils/custom-inflector-rules';
import 'cio/assets/styles/app.scss';

// Make sure moment extensions are loaded correctly
import moment from 'moment-timezone';
import 'moment-precise-range-plugin';
import momentDurationFormatSetup from 'moment-duration-format';
import '@glint/environment-ember-loose';

momentDurationFormatSetup(moment);

if (macroCondition(isDevelopingApp())) {
  importSync('cio/utils/deprecation-workflow');
}

// Uncomment these for debugging runloop exceptions:
// import { _backburner } from '@ember/runloop';

// Error.stackTraceLimit = 1000;
// _backburner.DEBUG = true;

startSentry();

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);

function statusLabelFor(status: string | null) {
  return status != null ? 'ON' : 'OFF';
}

window.cio = Object.create(null);
window.cio.environment = {
  ember: config.environment,
  cio: config.cioEnvironment,
};
window.cio.toggleFeature = function (feature: string) {
  let features = JSON.parse(localStorage.getItem('cio-features') ?? '{}') ?? {};

  if (features[feature] != null) {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    features[feature] = !features[feature];
  } else {
    features[feature] = true;
  }
  localStorage.setItem('cio-features', JSON.stringify(features));
  features = JSON.parse(localStorage.getItem('cio-features') ?? '{}');
  console.log(`Set ${feature} to ${statusLabelFor(features[feature])}`);
  console.log('App restart required to take effect, reloading…');

  setTimeout(function () {
    window.location.reload();
  }, 3000);
};

window.cio.showFeatures = function () {
  let features = JSON.parse(localStorage.getItem('cio-features') ?? '{}');
  for (let feature in features) {
    console.log(`Feature: ${feature} is ${statusLabelFor(features[feature])}`);
  }
};
